import { render, staticRenderFns } from "./alt-input.vue?vue&type=template&id=108b1f6c&"
import script from "./alt-input.vue?vue&type=script&lang=ts&"
export * from "./alt-input.vue?vue&type=script&lang=ts&"
import style0 from "./alt-input.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports